// extracted by mini-css-extract-plugin
module.exports = {"boxCore":"TierLevel_boxCore__22wwN","inputCard":"TierLevel_inputCard__3c2bd"};